import { Injectable, NgModule, defineInjectable } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class ConnectionService {
  constructor() {
    this.connectionMonitor = new Observable(observer => {
      window.addEventListener('offline', e => {
        observer.next(false);
      });
      window.addEventListener('online', e => {
        observer.next(true);
      });
    });
  }
  /**
   * @return {?}
   */
  monitor() {
    return this.connectionMonitor;
  }
}

/** @nocollapse */

/** @nocollapse */ConnectionService.ngInjectableDef = defineInjectable({
  factory: function ConnectionService_Factory() {
    return new ConnectionService();
  },
  token: ConnectionService,
  providedIn: "root"
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class ConnectionServiceModule {}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { ConnectionService, ConnectionServiceModule };

